import { useQuery, useQueryClient } from '@tanstack/react-query';
import { listOrgUnits, listAssets } from '@/services/appBookApi';

export const APPBOOK_ORG_UNITS_KEY = ['appbook', 'org-units'] as const;
export const appBookAssetsKey = (id: string) => ['appbook', 'assets', id] as const;

export function useAppBookOrgUnits() {
  return useQuery({
    queryKey: APPBOOK_ORG_UNITS_KEY,
    queryFn: listOrgUnits,
    staleTime: 30_000,
  });
}

export function useAppBookAssets(orgUnitId: string | null) {
  return useQuery({
    queryKey: orgUnitId ? appBookAssetsKey(orgUnitId) : ['appbook', 'assets', 'idle'],
    queryFn: () => listAssets(orgUnitId as string),
    enabled: !!orgUnitId,
    staleTime: 30_000,
  });
}

export function useInvalidateAppBook() {
  const qc = useQueryClient();
  return {
    invalidateOrgUnits: () => qc.invalidateQueries({ queryKey: APPBOOK_ORG_UNITS_KEY }),
    invalidateAssets: (id: string) => qc.invalidateQueries({ queryKey: appBookAssetsKey(id) }),
  };
}
